<template>
  <span v-if="!files.length" class="text-uppercase grey--text">Документы</span>
  <v-menu v-else v-model="fileMenu" offset-y :close-on-content-click="false">
    <template v-slot:activator="{ on }">
      <span
        class="text-uppercase grey--text text--darken-4 font-weight-bold link"
        v-on="on"
        >Документы
      </span>
    </template>
    <v-list v-if="files.length > 0">
      <v-list-tile v-for="file in files" :key="file.id" class="clickable-row">
        <v-menu open-on-hover offset-x>
          <template v-slot:activator="{ on }">
            <v-list-tile-content v-on="on">
              <v-list-tile-title v-text="file.originName" />
            </v-list-tile-content>
          </template>
        </v-menu>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>
<script>
import { notificationFilesTypes } from "../../enums/notification-types.js";
export default {
  props: ["files", "scrollValue"],
  data() {
    return {
      fileMenu: false,
    };
  },
  watch: {
    scrollValue() {
      if (!this.scrollValue) {
        return;
      }
      closeActivList(this.$children[0]);

      function closeActivList(value) {
        if (!value) {
          return;
        }
        if (value.isActive) {
          value.isActive = false;
        }
        if (value.$children) {
          value.$children.forEach((v) => closeActivList(v));
        }
      }
    },
  },
};
</script>
